import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import orderBluBarActive from '../../assets/img/order_blu_bar_active.png';
import orderBluBarInactive from '../../assets/img/order_blu_bar_inactive.png';
import orderTobaccoActive from '../../assets/img/order_tobacco_active.png';
import orderTobaccoInactive from '../../assets/img/order_tobacco_inactive.png';
import orderZoneActive from '../../assets/img/order_zone_active.png';
import orderZoneInactive from '../../assets/img/order_zone_inactive.png';

import './new-order-tabs.css';

const buttonWidth = 368;
const buttonHeight = 104;

class NewOrderTabs extends Component {
  render() {
    const { selectedTab, tab, onTabSelect } = this.props;
    const isTobaccoActive = selectedTab === tab.tobacco;
    const isBluBar = selectedTab === tab.bluBar;
    const isZone = selectedTab === tab.zone;
    const isBluBarActive = false; // Temporarily disable blu bar tab

    return(
      <div className="order-tab-container">
        <div className="order-tab-info">
          Click on either of the tabs below to add zone and tobacco products to your basket.
        </div>
        <br />
        <Button
          className="order-tab"
          onClick={() => onTabSelect(tab.zone)}
        >
          <img src={isZone ? orderZoneActive : orderZoneInactive} width={buttonWidth} height={buttonHeight} />
        </Button>

        <Button
          className="order-tab"
          onClick={() => onTabSelect(tab.tobacco)}
        >
          <img src={isTobaccoActive ? orderTobaccoActive : orderTobaccoInactive} width={buttonWidth} height={buttonHeight} />
        </Button>
        {isBluBarActive && (
          <Button
            className="order-tab"
            onClick={() => onTabSelect(tab.bluBar)}
          >
            <img src={isBluBar ? orderBluBarActive : orderBluBarInactive} width={buttonWidth} height={buttonHeight} />
          </Button>
        )}
      </div>
    );
  }
}

export default NewOrderTabs;



// WEBPACK FOOTER //
// ./src/components/new-order/new-order-tabs.jsx